"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/TemplatesDialog/TemplateList.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _controls = require('./controls');














/* The templates in the dialog's left column: name, scope, "ready" or "N to
 * fill" for this chat, and the first line as it'd read here. */
const TemplateList = ({ rows, selectedKey, locked, isLoading, query, draft, onChoose, onNew, onNewFromDraft }) => {
  const list = _react.useRef(null)
  // The chosen row stays in view as the arrow keys move it.
  _react.useEffect.call(void 0, () => {
    _optionalChain([list, 'access', _ => _.current, 'optionalAccess', _2 => _2.querySelector, 'call', _3 => _3('[aria-selected="true"]'), 'optionalAccess', _4 => _4.scrollIntoView, 'optionalCall', _5 => _5({ block: 'nearest' })])
  }, [selectedKey])

  if (isLoading) return _react2.default.createElement('p', { className: "templates-dialog--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}, "Loading templates…" )
  if (rows.length === 0) {
    const name = query.trim()
    return name
      ? (
        _react2.default.createElement('div', { className: "templates-dialog--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
          , _react2.default.createElement('b', { className: "templates-dialog--empty-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}, "No templates match \""   ,  name , "\"")
           /* A fixed label; the new template still starts with the search as its name. */ 
          , _react2.default.createElement(_controls.DialogButton, { variant: "out", small: true, className: "templates-dialog--empty-new", disabled: locked, onClick: () => onNew(name), __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}, "+ New template"

          )
        )
        )
      : (
        _react2.default.createElement('div', { className: "templates-dialog--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
          , _react2.default.createElement('div', { className: "templates-dialog--empty-icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "T")
          , _react2.default.createElement('b', { className: "templates-dialog--empty-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "No templates yet"  )
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}, "Save replies you send often, then insert them from Templates in any chat."            )
          , _react2.default.createElement('div', { className: "templates-dialog--empty-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
            , _react2.default.createElement(_controls.DialogButton, { small: true, disabled: locked, onClick: () => onNew(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, "+ New template"  )
            ,  draft.trim() && _react2.default.createElement(_controls.DialogButton, { variant: "out", small: true, disabled: locked, onClick: onNewFromDraft, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, "Save draft as template"   ) 
          )
        )
        )
  }
  return (
    _react2.default.createElement('div', { ref: list, className: "templates-dialog--list", role: "listbox", 'aria-label': "Templates", 'aria-disabled': locked || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
      ,  rows.map(row => {
        const key = row.template.TemplateKey
        return (
          _react2.default.createElement('div', {
            key: key,
            id: `templates-dialog-option-${key}`,
            role: "option",
            'aria-selected': key === selectedKey,
            'aria-disabled': locked || undefined,
            className: _classBuilder2.default.call(void 0, 'tdlg-row', key === selectedKey && 'tdlg-row--sel'),
            onClick: locked ? undefined : () => onChoose(key), __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}

            , _react2.default.createElement('div', { className: "tdlg-row--top", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
              , _react2.default.createElement('span', { className: "tdlg-row--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}},  row.template.Name )
              , _react2.default.createElement('span', { className: "tdlg-row--scope", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}},  row.scopeLabel )
              , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'tdlg-row--fill', row.missing === 0 && 'tdlg-row--ready'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
                ,  row.missing === 0 ? 'ready' : `${row.missing} to fill` 
              )
            )
            , _react2.default.createElement('div', { className: "tdlg-row--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
              ,  row.preview.map((segment, i) => segment.blank
                ? _react2.default.createElement('mark', { key: i, className: "tdlg-mark", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}},  segment.text.replace(/^\[|\]$/g, '').replace(/ /g, '_') )
                : _react2.default.createElement(_react2.default.Fragment, { key: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}},  segment.text ),
              )
            )
          )
        )
      })
      ,  draft.trim() && !locked && (
        _react2.default.createElement('button', { type: "button", className: "templates-dialog--from-draft", onClick: onNewFromDraft, __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}, "Save draft as template"   )
      )
    )
  )
}

exports. default = TemplateList
